import { useSelector } from "react-redux";
import { selectAccessToken, selectCurrentUser, selectTokenInfo } from "../services/authSlice";
import { useMemo, useState } from "react";

export const useUser = () => {
  const user = useSelector(selectCurrentUser);
  return useMemo(() => ({ user }), [user]);
};

export const useToken = () => {
  const token = useSelector(selectAccessToken);
  return useMemo(() => ({ token }), [token]);
};

export const useTokenInfo = () => {
  const tokenInfo = useSelector(selectTokenInfo);
  return useMemo(() => ({ tokenInfo }), [tokenInfo]);
};

export const useLoadingIndicator = (initialLoadingState) => {
  const [loading, setLoading] = useState(initialLoadingState);
  const [timerId, setTimerId] = useState(null);

  const startLoading = () => {
    setLoading(true);
    setTimerId(setTimeout(() => setLoading(false), 5000));
  };

  const stopLoading = () => {
    clearTimeout(timerId);
    setLoading(false);
  };

  return [loading, startLoading, stopLoading];
};
